<template>
  <v-layout
    justify-center
    align-center
  >
    <v-flex
      style="width: 100%">
      <v-menu
        ref="menu"
        :nudge-right="40"
        :return-value.sync="value"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          :value="displayValue"
          :label="label"
          :hint="hint"
          :rules="rules"
          prepend-icon="event"
          readonly
        />
        <v-date-picker
          v-model="value"
          :allowed-dates="allowedDates"
          :day-format="date => new Date(date).getDate()"
          :type="getType"
          :rules="rules"
          color="primary"
          max="2030"
          no-title
          locale="ja-jp"
          scrollable
          @change="onDateSelect"
        />
      </v-menu>
    </v-flex>
    <v-flex
      class="ml-1"
    >
      <v-icon
        v-if="value"
        class="clear"
        @click="clear">clear</v-icon>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.clear:hover {
  cursor: pointer;
}
</style>

<script>
import { VInput } from 'vuetify/lib';

export default {
  name: 'CpDatePicker',
  components: {
    VInput,
  },
  extends: VInput.VInput,
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    type: {
      type: [String, Function],
      default: 'date',
    },
    value: {
      type: String,
      default: null,
    },
    closeOnChange: {
      type: Boolean,
      default: false,
    },
    isLongDate: {
      type: Boolean,
      default: false,
    },
    showDay: {
      type: Boolean,
      default: true,
    },
    allowedDates: {
      type: null,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    rules: {
      type: [String, Number, Array],
      default: () => [],
    },
    label: {
      type: String,
      default: null,
    },
    hasFocused: {
      type: Boolean,
      default: false,
    },
    errorBucket: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displayValue() {
      return this.format(this.value);
    },
    getType() {
      if (this.isLongDate && !this.value) {
        return 'YEAR';
      }

      return this.type;
    },
  },
  methods: {
    onDateSelect(date) {
      this.$refs.menu.originalValue = date;
      this.$emit('input', date);
      this.$emit('change', date);

      if (this.closeOnChange) {
        this.$refs.menu.save(date);
      }
    },
    clear() {
      this.$emit('input', null);
      this.$emit('change', null);
    },
    format(value) {
      if (!value) {
        return '';
      }

      const date = new Date(value);
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2);
      const day = (`0${date.getDate()}`).slice(-2);

      if (!this.showDay) {
        return `${this.calcYear(year, month)}${month}月(${year})`;
      }

      return `${this.calcYear(year, month)}${month}月${day}日(${year})`;
    },
    calcYear(year, month) {
      if (year <= 1988) return `昭和${year - 1925}年`;

      if (year <= 2018 || (year === 2019 && month < 5)) {
        return `平成${parseInt(year, 10) === 1989 ? '元' : year - 1988}年`;
      }

      return `令和${parseInt(year, 10) === 2019 ? '元' : year - 2018}年`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/elements/CpDatePicker.vue